import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GrantSubscriptionPage } from '@/pages/subscriptions/grant-subscription-page';

/** Prefill via URL: ?customerType=user&customerId=... (used by Users/Teams detail links). */
const SearchSchema = z.object({
  customerType: z.enum(['user', 'team']).optional(),
  customerId: z.string().uuid().optional(),
});

export const Route = createFileRoute('/subscriptions/grant')({
  component: GrantSubscriptionPage,
  validateSearch: (s) => SearchSchema.parse(s),
});
